class ProductBatchStocks {
    constructor(properties) {
        this.statusCode = properties.statusCode ? properties.statusCode : '';
        this.statusMessage = properties.statusMessage ? properties.statusMessage : '';
        this.id = {
            key: properties.id && properties.id.key ? properties.id.key : '',
            value: properties.id && properties.id.value ? properties.id.value : ''
        };
        this.body = {
            mixedStocksAvailableQuantity: properties.body && properties.body.mixedStocksAvailableQuantity ? properties.body.mixedStocksAvailableQuantity : 0,
        };
    }
}

export default ProductBatchStocks;
